app.service("TabService", ['$rootScope', function ($rootScope) {

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const TabModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Tab",
        id: "tab",
        navigation_pointer: "tab_id",
        show_with_children: true
    });

    this.factory = new modelConstructor.RouteFactory({
        birth: function (values) {
            return new TabModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const browseID = variationIDs.browse_id;
        const solutionID = variationIDs.solution_id;
        const componentID = variationIDs.component_id;
        const requestRangeID = variationIDs.request_range_id;
        const parentCategoryGroupID = variationIDs.parent_category_group_id;
        const siteRangeID = variationIDs.site_range_id;
        const styleID = variationIDs.style_id;
        const colourID = variationIDs.colour_id;

        let choiceList = null
        let nextModelID = null;

        let choiceOrder = [];
        const choices = {};

        const showUntil = null;

        if (componentID === "solution_cabinet") {
            if (browseID === "solution") {
                const productSolutionModel = $rootScope.factory.product_solution.getModel(variationIDs);
                if (solutionID !== "bedroom_flat_pack") {
                    const choiceOrder = siteHelper.idListFromObjectList(productSolutionModel.categories.parent);
                    choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("solution", choiceOrder, ["bedroom", "non_component", "component"], parentCategoryGroupID, siteRangeID, colourID, styleID);
                    nextModelID = "select";

                } else {

                    const choiceOrder = ["robe", "chest", "bridging_unit"];
                    choiceList = $rootScope.service.cache_local_server.getAlphaCategoryChoiceList("solution", null, null, choiceOrder, null, siteRangeID, colourID, styleID);
                    nextModelID = "method_product";
                }
            } else {
                choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("solution", ["non_component"], null, parentCategoryGroupID, siteRangeID, colourID, styleID);
                nextModelID = "collection_product";
            }
        } else if (componentID === "solution_extra") {
            let panelWrapChoice = null;
            if (solutionID === "kitchen_rigid_flat_pack" && requestRangeID === "bella") {
                panelWrapChoice = new RouteChoice({
                    id: "panel",
                    name: "Panels"
                });
            } else if (solutionID === "kitchen_inrail") {
                if (requestRangeID === "bella") {
                    panelWrapChoice = new RouteChoice({
                        id: "panel_wrap",
                        name: "Panels & Wrap Panels"
                    });
                } else if (requestRangeID !== "pronto") {
                    panelWrapChoice = new RouteChoice({
                        id: "wrap",
                        name: "Wrap Panels"
                    });
                }
            }
            choiceList = [];
            if (panelWrapChoice) {
                panelWrapChoice.next_model_id = "tile";
                choiceList.push(panelWrapChoice);
            }

            let solutionComponentChoiceOrder;
            if (solutionID !== "bedroom_flat_pack") {
                solutionComponentChoiceOrder = ["appliance_door"];
            } else {
                solutionComponentChoiceOrder = ["kit", "end_panel", "plinth"];
            }

            const solutionComponentChoiceList = $rootScope.service.cache_local_server.getAlphaCategoryChoiceList("solution", null, null, solutionComponentChoiceOrder, null, siteRangeID, colourID, styleID);
            for (let i = 0; i < solutionComponentChoiceList.length; i++) {
                solutionComponentChoiceList[i].next_model_id = "collection_product";
            }
            choiceList = choiceList.concat(solutionComponentChoiceList);
        } else if (componentID === "handle_rail") {
            let choiceOrder;
            if (!solutionID) {
                choiceOrder = ["handle", "handleless_rail"];
            } else {
                if (solutionID !== "kitchen_inrail") {
                    choiceOrder = ["handle"];
                } else {
                    choiceOrder = ["handleless_rail"];
                }
            }
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", choiceOrder, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
            nextModelID = "collection_product";
        } else if (componentID === "hettich") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("hettich", ["hinge", "drawer", "accessory"]);
            nextModelID = "collection_product";
        }

        if (choiceList) {
            const addToChoiceOrder = !choiceOrder.length;
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                choices[choice.id] = choice;
                if (addToChoiceOrder) {
                    choiceOrder.push(choice.id);
                }
            }
        }

        model.choice_order = choiceOrder;
        model.choices = choices;
        model.default_choice_id = choiceOrder[0];
        model.next_model_id = nextModelID;
        model.showUntil = showUntil;
    }

}]);